import { BaseApi } from '../base';
import { ApiResponse } from '../../../types/api';

interface LoginParams {
  type: number;
  account?: string;
  password?: string;
  code?: string;
  oauth_id?: string;
  oauth_token?: string;
  name?: string;
}

interface roleInfoParams {
  token: string,
  isLastLogin: number,
  isLastRecharge: number,
  game_id: number[];
  parentGameId?: string
}

export class UserApi extends BaseApi {
  async login(params: LoginParams): Promise<ApiResponse> {
    return this.post('/v5/login', params);
  }

  async sendVerificationCode(params: { type: number; channel: number; number: string; captcha_verify_param?: string }): Promise<ApiResponse> {
    return this.post('/v5/send', params);
  }

  async resetPassword(data: { account: string; password: string; code: string }): Promise<ApiResponse> {
    return this.request({
      method: 'put',
      url: '/v5/reset-password',
      data
    });
  }

  // 校验token是否有效
  async checkToken(token: string): Promise<boolean> {
    const result = await this.get('/v5/login/check-token', { headers: { Authorization: `Bearer ${token}` } })
      .then((response: ApiResponse) => {
        return response.code === 200;
      }).catch(() => false);
    
    return result;
  }

  async getUserInfo(token: string): Promise<ApiResponse> {
    return this.get('/v5/user-info', { headers: { Authorization: `Bearer ${token}` } });
  }

  async getRoleInfo(params: roleInfoParams, showLoading = true): Promise<ApiResponse> {
    const { token, isLastLogin = 0, isLastRecharge = 0, game_id, parentGameId } = params;
    let paramsStr = `is_last_login=${isLastLogin}&is_last_recharge=${isLastRecharge}`;
    if (parentGameId !== '' && parentGameId !== undefined) {
      paramsStr += `&parent_game_id=${parentGameId}`;
    }
    if (game_id && game_id.length > 0) {
      paramsStr += game_id.map(id => `&game_id[]=${id}`).join('');
    }
    return this.get(`/v5/game-role-info?${paramsStr}`, {
      headers: { Authorization: `Bearer ${token}` },
      showLoading
    });
  }

  async createGuest(): Promise<ApiResponse> {
    return this.post('/v5/guest');
  }

  async getGameLoginInfo(token: string): Promise<ApiResponse> {
    return this.get('/v5/game-login', {headers: { Authorization: `Bearer ${token}` } })
  }
}